import products from "../data/products";
import ProductCard from "./ProductCard";

function Products() {
  return (
<section className="products" id="shop">
          <h2>Featured Products 🐱</h2>
      <div className="product-grid">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
}

export default Products;